import { useEffect, useState } from 'react';

export const useDeviceMatch = (mediaQuery) => {
  const [isDeviceMatch, setDeviceMatch] = useState(window.matchMedia(mediaQuery).matches);

  useEffect(() => {
    const media = window.matchMedia(mediaQuery);

    if (media.matches !== isDeviceMatch) setDeviceMatch(media.matches);

    const listener = () => setDeviceMatch(media.matches);
    media.addEventListener('change', listener);

    return () => media.removeEventListener('change', listener);
  }, [isDeviceMatch, mediaQuery]);

  return isDeviceMatch;
};